import { render, staticRenderFns } from "./EditProxyError.vue?vue&type=template&id=bd23a25e&"
import script from "./EditProxyError.vue?vue&type=script&lang=ts&"
export * from "./EditProxyError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports